import { Component } from '@angular/core';

@Component({
  selector: 'ao-oren-error',
  templateUrl: './error.component.html',
})
export class ErrorComponent {}
